import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import AsphaltPaving from "../pages/services/asphalt-paving/page";
import Locations from "../pages/locations/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/services/asphalt-paving",
    element: <AsphaltPaving />,
  },
  {
    path: "/locations",
    element: <Locations />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
